export default __webpack_public_path__ + "static/m-hnh2-6d6879fdb67ac4e8b04e8dce21749ab2.jpg";